import { docReady } from './utils';
import detectorInit from './detector';
import formValidationInit from './form-validation';
import dropdownOnHover from './dropdown-on-hover';
import dropdownMenuInit from './dropdown-menu';
import scrollInit from './scroll';
import typedTextInit from './typed';
import initMap from './googleMap';
import parallaxInit from './parallax';
import swiperInit from './swiper';
import formSubmissionInit from './form-submission';
import lightboxInit from './lightbox';
import bgPlayerInit from './bg-player';
import isotopeInit from './isotope';
import tabsInit from './tabs';
import tooltipInit from './tooltip';
import formInputFileInit from './form-inputfile';
import hamburgerInit from './hamburger';
import formInit from './form-processor';

/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */
docReady(detectorInit);
docReady(formValidationInit);
docReady(dropdownOnHover);
docReady(dropdownMenuInit);
docReady(scrollInit);
docReady(typedTextInit);
docReady(initMap);
docReady(parallaxInit);
docReady(swiperInit);
docReady(formSubmissionInit);
docReady(lightboxInit);
docReady(bgPlayerInit);
docReady(isotopeInit);
docReady(tabsInit);
docReady(tooltipInit);
docReady(formInputFileInit);
docReady(hamburgerInit);
docReady(formInit);
